import React from "react";
import { Password } from "primereact/password";

const PasswordInput = ({ password, handleChange, isValid, pLabel }) => {
  let pName = "password";
  if (pLabel === "Current Password") pName = "oldPassword";
  if (pLabel === "Confirm New Password") pName = "passwordConfirm";
  return (
    <div className='p-field k-mb-2r'>
      <span className='p-float-label'>
        <Password
          name={pName}
          value={password}
          onChange={handleChange}
          className={!isValid && "p-invalid"}
          feedback={false}
        />
        <label htmlFor={password}>{pLabel}</label>
      </span>
    </div>
  );
};

export default PasswordInput;
